import React, { useEffect, useState } from 'react'
import { List, ListItemButton, ListItemText } from '@mui/material'
import { ExternalLink } from 'react-feather'
import { useLocation, useNavigate } from 'react-router-dom'
import urlBuilder from '../../../../utils/UrlBuilder'
import { Trans } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import { navMenuButtonStyles, navMenuTextStyles } from './NavMenu.styles'
import { BILLING, COMMUNICATION, INTEGRATIONS, SETTINGS } from '../../../../routes/SettingsRoutes'
import { useFeatureFlags } from '../../../../utils/FeatureFlags/useFeatureFlags'

export default function NavMenu() {
	const navigate = useNavigate()
	const { palette } = useTheme()
	const { pathname } = useLocation()
	const { FRONTEND_BILLING_PAGE } = useFeatureFlags()
	const [activeSection, setActiveSection] = useState('')

	useEffect(() => {
		setActiveSection(pathname)
	}, [pathname])

	return (
		<List sx={{ display: 'flex' }} dense={true} component="nav" aria-label="main mailbox folders">
			<ListItemButton
				component="button"
				onClick={() => navigate(SETTINGS)}
				sx={{ ...navMenuButtonStyles, pl: 0 }}
			>
				<ListItemText sx={navMenuTextStyles(palette, SETTINGS === activeSection)}>
					<Trans i18nKey="account.nav_menu_profile_label" />
				</ListItemText>
			</ListItemButton>
			<ListItemButton
				component="button"
				onClick={() => navigate(urlBuilder([SETTINGS, COMMUNICATION]))}
				sx={navMenuButtonStyles}
			>
				<ListItemText sx={navMenuTextStyles(palette, urlBuilder([SETTINGS, COMMUNICATION]) === activeSection)}>
					<Trans i18nKey="account.nav_menu_communication_label" />
				</ListItemText>
			</ListItemButton>
			<ListItemButton
				component="button"
				onClick={() => navigate(urlBuilder([SETTINGS, INTEGRATIONS]))}
				sx={navMenuButtonStyles}
			>
				<ListItemText sx={navMenuTextStyles(palette, urlBuilder([SETTINGS, INTEGRATIONS]) === activeSection)}>
					<Trans i18nKey="account.nav_menu_integrations_label" />
				</ListItemText>
			</ListItemButton>
			{FRONTEND_BILLING_PAGE && (
				<ListItemButton
					component="button"
					onClick={() => navigate(urlBuilder([SETTINGS, BILLING]))}
					sx={navMenuButtonStyles}
				>
					<ListItemText sx={navMenuTextStyles(palette, urlBuilder([SETTINGS, BILLING]) === activeSection)}>
						<Trans i18nKey="account.nav_menu_billing_label" />
					</ListItemText>
				</ListItemButton>
			)}
			<ListItemButton
				component="a"
				href={process.env.REACT_APP_EDIT_SUBSCRIPTION}
				target="_blank"
				sx={{ ...navMenuButtonStyles, gap: '6px' }}
			>
				<ListItemText sx={navMenuTextStyles(palette, false)}>
					<Trans i18nKey="account.nav_menu_subscription_label" />
				</ListItemText>
				<ExternalLink style={{ width: '1rem', color: palette.text.lightGrey }} />
			</ListItemButton>
		</List>
	)
}
